import { Link, createHashRouter, RouterProvider } from 'react-router-dom'
import Login from './pages/login/Login'
import MainLayout from './pages/main/MainLayout'
import MainPage from './pages/main/MainPage'

const NoMatch = () => {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  )
}

const basename = '/'

// createHashRouter, createBrowserRouter
export const router = createHashRouter([
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { index: true, element: <MainPage /> },
      // admin
      { path: 'admins/add', lazy: () => import('./pages/admins/Add') },
      { path: 'admins/modify/:id', lazy: () => import('./pages/admins/Add') },
      { path: 'admins/list', lazy: () => import('./pages/admins/List') },
      // menu
      { path: 'menu/add', lazy: () => import('./pages/menu/Add') },
      { path: 'menu/modify/:id', lazy: () => import('./pages/menu/Add') },
      { path: 'menu/list', lazy: () => import('./pages/menu/List') },
      // movie
      { path: 'movie/add', lazy: () => import('./pages/movie/Add') },
      { path: 'movie/modify/:page/:id', lazy: () => import('./pages/movie/Add') },
      { path: 'movie/list/:page', lazy: () => import('./pages/movie/List') },
      // diary
      { path: 'diary/add', lazy: () => import('./pages/diary/Add') },
      { path: 'diary/modify/:page/:id', lazy: () => import('./pages/diary/Add') },
      { path: 'diary/list/:page', lazy: () => import('./pages/diary/List') },
      // dailyRun
      { path: 'dailyRun/add', lazy: () => import('./pages/dailyRun/Add') },
      { path: 'dailyRun/modify/:id', lazy: () => import('./pages/dailyRun/Add') },
      { path: 'dailyRun/list', lazy: () => import('./pages/dailyRun/List') },
      // marathon
      { path: 'marathon/add', lazy: () => import('./pages/marathon/Add') },
      { path: 'marathon/modify/:id', lazy: () => import('./pages/marathon/Add') },
      { path: 'marathon/list', lazy: () => import('./pages/marathon/List') },
      // petrol
      { path: 'petrol/add', lazy: () => import('./pages/petrol/Add') },
      { path: 'petrol/modify/:page/:id', lazy: () => import('./pages/petrol/Add') },
      { path: 'petrol/list/:page', lazy: () => import('./pages/petrol/List') },
      // Amazon/CurrencyRate
      { path: 'amazon/currencyRate/add', lazy: () => import('./pages/amazon/currencyRate/Add') },
      { path: 'amazon/currencyRate/modify/:page/:id', lazy: () => import('./pages/amazon/currencyRate/Add') },
      { path: 'amazon/currencyRate/list/:page', lazy: () => import('./pages/amazon/currencyRate/List') },
      // Amazon/Aliexpress/Totals
      { path: 'amazon/aliexpress/totals/list/:page', lazy: () => import('./pages/amazon/aliexpress/totals/List') },
      // Amazon/Aliexpress/Zgf
      { path: 'amazon/aliexpress/zgf/add', lazy: () => import('./pages/amazon/aliexpress/zgf/Add') },
      { path: 'amazon/aliexpress/zgf/modify/:page/:id', lazy: () => import('./pages/amazon/aliexpress/zgf/Add') },
      { path: 'amazon/aliexpress/zgf/list/:page', lazy: () => import('./pages/amazon/aliexpress/zgf/List') },
      // Amazon/Aliexpress/Ljl
      { path: 'amazon/aliexpress/ljl/add', lazy: () => import('./pages/amazon/aliexpress/ljl/Add') },
      { path: 'amazon/aliexpress/ljl/modify/:page/:id', lazy: () => import('./pages/amazon/aliexpress/ljl/Add') },
      { path: 'amazon/aliexpress/ljl/list/:page', lazy: () => import('./pages/amazon/aliexpress/ljl/List') },
      // Amazon/Aliexpress/A
      { path: 'amazon/aliexpress/a/add', lazy: () => import('./pages/amazon/aliexpress/a/Add') },
      { path: 'amazon/aliexpress/a/modify/:page/:id', lazy: () => import('./pages/amazon/aliexpress/a/Add') },
      { path: 'amazon/aliexpress/a/list/:page', lazy: () => import('./pages/amazon/aliexpress/a/List') },
      // Amazon/Aliexpress/樊宏贵
      { path: 'amazon/aliexpress/t_FanHongGui/add', lazy: () => import('./pages/amazon/aliexpress/t_FanHongGui/Add') },
      { path: 'amazon/aliexpress/t_FanHongGui/modify/:page/:id', lazy: () => import('./pages/amazon/aliexpress/t_FanHongGui/Add') },
      { path: 'amazon/aliexpress/t_FanHongGui/list/:page', lazy: () => import('./pages/amazon/aliexpress/t_FanHongGui/List') },
      // Amazon/Aliexpress/符克周
      { path: 'amazon/aliexpress/t_FuKeZhou/add', lazy: () => import('./pages/amazon/aliexpress/t_FuKeZhou/Add') },
      { path: 'amazon/aliexpress/t_FuKeZhou/modify/:page/:id', lazy: () => import('./pages/amazon/aliexpress/t_FuKeZhou/Add') },
      { path: 'amazon/aliexpress/t_FuKeZhou/list/:page', lazy: () => import('./pages/amazon/aliexpress/t_FuKeZhou/List') },
      // Amazon/Aliexpress/黄伟
      { path: 'amazon/aliexpress/t_HuangWei/add', lazy: () => import('./pages/amazon/aliexpress/t_HuangWei/Add') },
      { path: 'amazon/aliexpress/t_HuangWei/modify/:page/:id', lazy: () => import('./pages/amazon/aliexpress/t_HuangWei/Add') },
      { path: 'amazon/aliexpress/t_HuangWei/list/:page', lazy: () => import('./pages/amazon/aliexpress/t_HuangWei/List') },
      // Amazon/Aliexpress/孙震宇
      { path: 'amazon/aliexpress/t_SunZhenYu/add', lazy: () => import('./pages/amazon/aliexpress/t_SunZhenYu/Add') },
      { path: 'amazon/aliexpress/t_SunZhenYu/modify/:page/:id', lazy: () => import('./pages/amazon/aliexpress/t_SunZhenYu/Add') },
      { path: 'amazon/aliexpress/t_SunZhenYu/list/:page', lazy: () => import('./pages/amazon/aliexpress/t_SunZhenYu/List') },
      // Amazon/rent/Zgf
      { path: 'amazon/rent/zgf/add', lazy: () => import('./pages/amazon/rent/zgf/Add') },
      { path: 'amazon/rent/zgf/modify/:page/:id', lazy: () => import('./pages/amazon/rent/zgf/Add') },
      { path: 'amazon/rent/zgf/list/:page', lazy: () => import('./pages/amazon/rent/zgf/List') },
      // Amazon/rent/Ljl
      { path: 'amazon/rent/ljl/add', lazy: () => import('./pages/amazon/rent/ljl/Add') },
      { path: 'amazon/rent/ljl/modify/:page/:id', lazy: () => import('./pages/amazon/rent/ljl/Add') },
      { path: 'amazon/rent/ljl/list/:page', lazy: () => import('./pages/amazon/rent/ljl/List') },
      // aax.world amazon
      { path: 'amazon/aax/add', lazy: () => import('./pages/amazon/aax/Add') },
      { path: 'amazon/aax/modify/:page/:id', lazy: () => import('./pages/amazon/aax/Add') },
      { path: 'amazon/aax/list/:page', lazy: () => import('./pages/amazon/aax/List') },
      // Amazon/Yunexpress
      { path: 'yunexpress/add', lazy: () => import('./pages/yunexpress/Add') },
      { path: 'yunexpress/modify/:page/:id', lazy: () => import('./pages/yunexpress/Add') },
      { path: 'yunexpress/list/:page', lazy: () => import('./pages/yunexpress/List') },
      // Salary EChart
      { path: 'salary', lazy: () => import('./pages/SalaryEChart') },
      {
        path: 'dashboard',
        async lazy () {
          let { DashboardLayout } = await import('./pages/Dashboard')
          return { Component: DashboardLayout }
        },
        children: [
          {
            index: true,
            async lazy() {
              let { DashboardIndex } = await import("./pages/Dashboard");
              return { Component: DashboardIndex };
            },
          },
          {
            path: "messages",
            async lazy() {
              let { dashboardMessagesLoader, DashboardMessages } = await import("./pages/Dashboard");
              return {
                loader: dashboardMessagesLoader,
                Component: DashboardMessages,
              };
            },
          },
        ],
      },
      { path: "*", element: <NoMatch /> }
    ]
  }
], { basename })




/*
//-----------------
// 如果需要异步lazy
//-----------------
{
  path: "dashboard",
  lazy: async () => {
    // Multiple routes in lazy file
    let { DashboardLayout } = await import("./pages/Dashboard");
    return { Component: DashboardLayout };
  }
}
//----------------
// Dashboard.js
//----------------
import { useLoaderData } from 'react-router-dom'
export const DashboardLayout = () => <nav />
export const msgLoader = async () => {
  await new Promise((r) => setTimeout(r, 300))
  return {
    messages: ['Message 1', 'Message 2', 'Message 3']
  }
}
export const msg = () => {
  let { messages } = useLoaderData()
  return (
    <div>
      <ul>{messages.map((m) => <li key={m}>{m}</li>)}</ul>
    </div>
  )
}
*/


const Router = <RouterProvider router={router} fallbackElement={<p>Loading...</p>} />

export default Router
